import { connect } from 'react-redux';
import {
    Experiment as BaseExperiment,
    Variant as BaseVariant,
} from '../components/experiments/Experiment';

/**
 * Use this container as a replacement for the Experiment component
 * that has the current page domain automatically populated sdo you don't have to pass it
 * on every instance.
 */
export const Experiment = connect((state) => ({
    domain: state.app.ebDomain || '',
    enableFVParams: !state.app.isProd,
}))(BaseExperiment);

export const Variant = BaseVariant;
